import { Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Skeleton } from "antd";
import "../styles/base.scss";
import EmployeeManagement from "../views/EmployeeManagement/EmployeeManagement";
import NotFound from "../components/NotFound";
import ShopDataGate from "../components/ShopDataGate/ShopDataGate";

const Dashboard = lazy(() => import("../views/DashBoard/DashBoard"));
const ProductEditPageWidget = lazy(
  () => import("../views/GlobalCatalogManagement/Form/ProductEditPageWidget")
);
const GlobalCatalogManagement = lazy(
  () => import("../views/GlobalCatalogManagement/GlobalCatalogManagement")
);
const ShopCatalogManagement = lazy(
  () => import("../views/ShopCatalogManagement/ShopCatalogManagement")
);
const SingleShopCatalogManagement = lazy(
  () => import("../views/ShopCatalogManagement/SingleShopCatalogManagement")
);
const ShopProductEditPageWidget = lazy(
  () => import("../views/ShopCatalogManagement/Form/ShopProductEditPageWidget")
);
const ShopEditForm = lazy(
  () => import("../views/ShopCatalogManagement/ShopEditForm/ShopEditForm")
);
const ShopConfigPage = lazy(
  () => import("../views/ShopConfig/ShopConfigPage")
);
const Orders = lazy(() => import("../views/OrderManagement/Orders"));
const OrderDetails = lazy(
  () => import("../views/OrderManagement/OrderDetails/OrderDetails")
);
const CatalogAutomationToolManagement = lazy(
  () => import("../views/CatalogAutomationTool/CatalogAutomationToolManagement")
);
const CatUpload = lazy(
  () => import("../views/CatalogAutomationTool/CatUpload/CatUpload")
);
const CatUpManagement = lazy(
  () => import("../views/CatUp/CatUpManagement")
);
const KycManagement = lazy(() => import("../views/KycPage/KycManagement"));
const KycUpload = lazy(() => import("../views/KycPage/KycForm/KycUpload"));
const SingleShopOfferManagement = lazy(
  () => import("../views/ShopCatalogManagement/SingleShopOfferManagement")
);
const OfferEditPage = lazy(
  () => import("../views/ShopCatalogManagement/ShopOffer/OfferEditPage")
);
const IncomingPayment = lazy(
  () => import("../views/IncomingPayment/IncomingPayment")
);
const PaymentDetails = lazy(
  () => import("../views/IncomingPayment/PaymentDetails")
);
const SelectSubcategoryBrand = lazy(
  () => import("../views/ShopCatalogManagement/SelectSubcategoryBrand")
);
const SelectProductWithName = lazy(
  () => import("../views/ShopCatalogManagement/SelectProductWithName")
);
const SelectProductWithBarcode = lazy(
  () => import("../views/ShopCatalogManagement/SelectProductWithBarcode")
);
const SingleShopOutgoingPayment = lazy(
  () => import("../views/ShopCatalogManagement/SingleShopOutgoingPayment")
);
const SingleOutgoingPaymentDetails = lazy(
  () => import("../views/ShopCatalogManagement/SingleOutgoingPaymentDetails")
);
const OndcReport = lazy(() => import("../views/OndcReport/OndcReports"));
const Bills = lazy(() => import("../views/BillManagement/Bills"));
const ShopOnboarding = lazy(
  () => import("../views/ShopOnboarding/ShopOnboarding")
);
const CustomersPage = lazy(
  () => import("../views/Customers/CustomersPage")
);
const CustomerDetailPage = lazy(
  () => import("../views/Customers/CustomerDetailPage")
);
const SubscriptionManagement = lazy(
  () => import("../views/Subscription/SubscriptionManagement")
);
const SubscriptionPlansManagement = lazy(
  () => import("../views/SubscriptionPlans/SubscriptionPlansManagement")
);

const AuthRoutes = () => {
  return (
    <ShopDataGate>
      <div className="auth-routes-wrapper">
        <Suspense
          fallback={
            <div className="loading-div">
              <Skeleton active />
            </div>
          }
        >
          <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/create-product" element={<ProductEditPageWidget />} />
          <Route
            path="/update-product/:id"
            element={<ProductEditPageWidget />}
          />
          <Route
            path="/migrate-product/:id"
            element={<ProductEditPageWidget />}
          />
          <Route
            path="/global-catalog-management"
            element={<GlobalCatalogManagement />}
          />
          <Route
            path="/catalog-automation-tool"
            element={<CatalogAutomationToolManagement />}
          />
          <Route path="/new-cat-upload" element={<CatUpload />} />
          <Route path="/cat-up" element={<CatUpManagement />} />
          <Route path="/cat-up-product/:id" element={<ProductEditPageWidget />} />
          <Route path="/all-shops" element={<ShopCatalogManagement />} />
          <Route path="/edit-shop/:id" element={<ShopEditForm />} />
          <Route path="/shop-config/:id" element={<ShopConfigPage />} />
          <Route
            path="/single-shop-catalog/:id"
            element={<SingleShopCatalogManagement />}
          />
          <Route
            path="/create-shop-product"
            element={<ShopProductEditPageWidget />}
          />
          <Route
            path="/update-shop-product/:id"
            element={<ShopProductEditPageWidget />}
          />
          <Route
            path="/create-draft-product"
            element={<ShopProductEditPageWidget />}
          />
          <Route
            path="/add-from-catalog"
            element={<SelectSubcategoryBrand />}
          />
          <Route
            path="/add-from-catalog-with-product-name"
            element={<SelectProductWithName />}
          />
          <Route
            path="/add-from-catalog-with-product-barcode"
            element={<SelectProductWithBarcode />}
          />
          <Route
            path="/update-draft-product/:id"
            element={<ShopProductEditPageWidget />}
          />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/*" element={<OrderDetails />} />
          <Route path="/shop-kyc" element={<KycManagement />} />
          <Route path="/update-shop-kyc" element={<KycUpload />} />
          <Route
            path="/single-shop-offers/:id"
            element={<SingleShopOfferManagement />}
          />
          <Route path="/create-new-offer" element={<OfferEditPage />} />
          <Route path="/update-offer/:id" element={<OfferEditPage />} />
          <Route path="/incoming-payments" element={<IncomingPayment />} />
          <Route path="/payment-details/:id" element={<PaymentDetails />} />
          <Route
            path="/single-shop-outgoing-payment/:id"
            element={<SingleShopOutgoingPayment />}
          />
          <Route
            path="/single-shop-outgoing-payment/payment-details/:id"
            element={<SingleOutgoingPaymentDetails />}
          />
          <Route path="/ondc-report" element={<OndcReport />} />
          <Route path="/employee-management" element={<EmployeeManagement />} />
          <Route path="/shop-onboarding" element={<ShopOnboarding />} />
          <Route path="/bills" element={<Bills />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route
            path="/customers/:phoneNumber"
            element={<CustomerDetailPage />}
          />
          <Route
            path="/single-shop-subscription/:id"
            element={<SubscriptionManagement />}
          />
          <Route
            path="/subscription-plans"
            element={<SubscriptionPlansManagement />}
          />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </div>
    </ShopDataGate>
  );
};

export default AuthRoutes;
